<template>
  <div id="mainTabBar">
    <left-tab-bar>
      <!--注册会员管理-->
      <left-tab-bar-item>
        <img slot="item-icon" src="../../../assets/img/user_icon.svg" alt="">
        <strong slot="item-text">注册会员管理</strong>
        <img slot="item-open" src="../../../assets/img/open.svg" alt="">
        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">
        <left-tab-bar-item slot="item-child" @goTo="goTo" :url="'/user/list'">
          <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
          <div slot="item-text">注册会员资料表</div>
        </left-tab-bar-item>
      </left-tab-bar-item>
      <!--农基商管理-->
      <left-tab-bar-item>
        <img slot="item-icon" src="../../../assets/img/merchants_icon.svg" alt="">
        <strong slot="item-text">农基商管理</strong>
        <img slot="item-open" src="../../../assets/img/open.svg" alt="">
        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">
        <div slot="item-child">
          <left-tab-bar-item @goTo="goTo" :url="'/merchants/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">农基商资料列表</div>
          </left-tab-bar-item>
          <left-tab-bar-item>
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">农基商收支列表</div>
          </left-tab-bar-item>
        </div>
      </left-tab-bar-item>
      <!--采集管理-->
      <left-tab-bar-item>
        <img slot="item-icon" src="../../../assets/img/admin_icon.svg" alt="">
        <strong slot="item-text">采集管理</strong>
        <img slot="item-open" src="../../../assets/img/open.svg" alt="">
        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">
        <div slot="item-child">
          <left-tab-bar-item @goTo="goTo" :url="'/collector/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">采集商列表</div>
          </left-tab-bar-item>
          <left-tab-bar-item @goTo="goTo" :url="'/collector/orderList'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">采集单列表</div>
          </left-tab-bar-item>
        </div>
      </left-tab-bar-item>
      <!--心坞栈管理-->
      <left-tab-bar-item>
        <img slot="item-icon" src="../../../assets/img/xshoplus.svg" alt="">
        <strong slot="item-text">心坞栈管理</strong>
        <img slot="item-open" src="../../../assets/img/open.svg" alt="">
        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">
        <div slot="item-child">
          <left-tab-bar-item @goTo="goTo" :url="'/coveShedAddress/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">心坞栈区域列表</div>
          </left-tab-bar-item>
        </div>
        <div slot="item-child">
          <left-tab-bar-item @goTo="goTo" :url="'/coveShed/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">心坞栈列表</div>
          </left-tab-bar-item>
        </div>
      </left-tab-bar-item>
      <!--农商品管理-->
      <left-tab-bar-item>
        <img slot="item-icon" src="../../../assets/img/plan_icon.svg" alt="">
        <strong slot="item-text">农商品管理</strong>
        <img slot="item-open" src="../../../assets/img/open.svg" alt="">
        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">
        <div slot="item-child">
          <left-tab-bar-item @goTo="goTo" :url="'/pmsSkuInfo/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">地球计划列表</div>
          </left-tab-bar-item>
<!--          <left-tab-bar-item @goTo="goTo" :url="'/video/list'">-->
<!--            <img slot="item-icon" src="../../../assets/img/star.svg" alt="">-->
<!--            <div slot="item-text">心味厨房列表</div>-->
<!--          </left-tab-bar-item>-->
          <left-tab-bar-item @goTo="goTo" :url="'/dailyPush/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">每周精选列表</div>
          </left-tab-bar-item>
          <left-tab-bar-item @goTo="goTo" :url="'/swiper/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">轮播图商品列表</div>
          </left-tab-bar-item>
          <left-tab-bar-item @goTo="goTo" :url="'/skuLabel/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">商品标签管理</div>
          </left-tab-bar-item>
        </div>
      </left-tab-bar-item>
      <!--订单管理-->
      <left-tab-bar-item>
        <img slot="item-icon" src="../../../assets/img/order_icon.svg" alt="">
        <strong slot="item-text">订单管理</strong>
        <img slot="item-open" src="../../../assets/img/open.svg" alt="">
        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">
        <div slot="item-child">
          <left-tab-bar-item  @goTo="goTo" :url="'/order/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">订单列表</div>
          </left-tab-bar-item>
          <left-tab-bar-item>
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">收支列表</div>
          </left-tab-bar-item>
        </div>
      </left-tab-bar-item>
      <!--营销活动管理-->
<!--      <left-tab-bar-item>-->
<!--        <img slot="item-icon" src="../../../assets/img/huodong.svg" alt="">-->
<!--        <strong slot="item-text">会员营销管理</strong>-->
<!--        <img slot="item-open" src="../../../assets/img/open.svg" alt="">-->
<!--        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">-->
<!--        <div slot="item-child">-->
<!--          <left-tab-bar-item @goTo="goTo" :url="'/marketingMerchants/list'">-->
<!--            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">-->
<!--            <div slot="item-text">营销商户列表</div>-->
<!--          </left-tab-bar-item>-->
<!--          <left-tab-bar-item @goTo="goTo" :url="'/activity/list'">-->
<!--            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">-->
<!--            <div slot="item-text">营销活动列表</div>-->
<!--          </left-tab-bar-item>-->
<!--        </div>-->
<!--      </left-tab-bar-item>-->
      <!--卡券管理-->
      <left-tab-bar-item>
        <img slot="item-icon" src="../../../assets/img/coupons_icon.svg" alt="">
        <strong slot="item-text">卡券管理</strong>
        <img slot="item-open" src="../../../assets/img/open.svg" alt="">
        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">
        <div slot="item-child">
          <left-tab-bar-item  @goTo="goTo" :url="'/coupons/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">绿能券列表</div>
          </left-tab-bar-item>
          <left-tab-bar-item  @goTo="goTo" :url="'/userCoupons/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">已领取列表</div>
          </left-tab-bar-item>
        </div>
      </left-tab-bar-item>
      <!--支农体验管理-->
      <left-tab-bar-item>
        <img slot="item-icon" src="../../../assets/img/sharexsalo.svg" alt="">
        <strong slot="item-text">爱助农管理</strong>
        <img slot="item-open" src="../../../assets/img/open.svg" alt="">
        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">
        <div slot="item-child">
          <left-tab-bar-item @goTo="goTo" :url="'/share/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">支农列表</div>
          </left-tab-bar-item>
          <left-tab-bar-item @goTo="goTo" :url="'/reflectRecord/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">提现记录</div>
          </left-tab-bar-item>
          <!--          <left-tab-bar-item>-->
          <!--            <img slot="item-icon" src="../../../assets/img/star.svg" alt="">-->
          <!--            <div slot="item-text">分享海报列表</div>-->
          <!--          </left-tab-bar-item>-->
        </div>
      </left-tab-bar-item>
      <!--网站信息管理-->
      <left-tab-bar-item>
        <img slot="item-icon" src="../../../assets/img/message_icon.svg" alt="">
        <strong slot="item-text">系统信息管理</strong>
        <img slot="item-open" src="../../../assets/img/open.svg" alt="">
        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">
        <div slot="item-child">
          <left-tab-bar-item @goTo="goTo" :url="'/version/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">版本信息列表</div>
          </left-tab-bar-item>
          <left-tab-bar-item @goTo="goTo" :url="'/guideImg/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">开始页图片列表</div>
          </left-tab-bar-item>
          <left-tab-bar-item @goTo="goTo" :url="'/terms/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">条款信息列表</div>
          </left-tab-bar-item>
          <left-tab-bar-item @goTo="goTo" :url="'/systemMessage/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">系统信息列表</div>
          </left-tab-bar-item>
        </div>
      </left-tab-bar-item>
      <!--平台管理员管理-->
      <left-tab-bar-item>
        <img slot="item-icon" src="../../../assets/img/admin_icon.svg" alt="">
        <strong slot="item-text">平台管理员管理</strong>
        <img slot="item-open" src="../../../assets/img/open.svg" alt="">
        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">
        <div slot="item-child">
          <left-tab-bar-item @goTo="goTo" :url="'/admin/list'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">管理员列表</div>
          </left-tab-bar-item>
        </div>
      </left-tab-bar-item>
      <!--公共设置      -->
      <left-tab-bar-item>
        <img slot="item-icon" src="../../../assets/img/sharexsalo.svg" alt="">
        <strong slot="item-text">公共设置管理</strong>
        <img slot="item-open" src="../../../assets/img/open.svg" alt="">
        <img slot="item-hidden" src="../../../assets/img/hidden.svg" alt="">
        <div slot="item-child">
          <left-tab-bar-item @goTo="goTo" :url="'/distribution/distributionConfiguration'">
            <img slot="item-icon" src="../../../assets/img/nav-list.svg" alt="">
            <div slot="item-text">分销设置</div>
          </left-tab-bar-item>
        </div>
      </left-tab-bar-item>
    </left-tab-bar>
  </div>
</template>

<script>
  import LeftTabBar from "../../common/leftTabbar/LeftTabBar";
  import LeftTabBarItem from "../../common/leftTabbar/LeftTabBarItem";
  export default {
    name: "MainTabBar",
    components: {LeftTabBarItem, LeftTabBar},
    methods: {
      goTo(url){
        this.$router.push(url);
      }
    }
  }
</script>

<style scoped>
  #mainTabBar{
    position: fixed;
    z-index: 11;
    width: 200px;
    height: 100vh;
    overflow: scroll;
    background-color: #2a2c36;
    top: 0;
  }
</style>
